import { setDeptIndent } from './index'
import { useAutoWidgetPlugins as _useAutoWidgetPlugins } from '../../../../plugins/widget'

function byteLength (text) {
  let len = 0
  const str = String(text)
  if (!str) {
    return len
  }
  for (let i = 0; i < str.length; i++) {
    const charCode = str.charCodeAt(i)
    if (charCode <= 255) {
      len += 1
    } else {
      len += 2 // 非ASCII字符（例如中文）
    }
  }
  return len
}

function createPaintSourceText (vm, key, plus) {
  const obj = vm.displayRow.reduce((obj, cur, i) => {
    const index = cur.index
    const flatDataItem = vm.flatData[index][key]
    const dataItem = vm.data[index][key]
    const l = byteLength(dataItem)
    if (plus) {
      if (i === 0) {
        obj.leng = l
        obj.maxPaintText = flatDataItem
        obj.maxSourceText = dataItem
      } else {
        if (obj.leng > l && dataItem) {
          obj.leng = l
          obj.maxPaintText = flatDataItem
          obj.maxSourceText = dataItem
        }
      }
    } else {
      if (obj.leng < l) {
        obj.leng = l
        obj.maxPaintText = flatDataItem
        obj.maxSourceText = dataItem
      }
    }
    return obj
  }, {
    leng: 0,
    maxPaintText: null,
    maxSourceText: null
  })
  return obj
}


export function useAutoWidgetPlugins (vm) {
  const params = {
    getMeasureTextWidth: (text) => vm.textCtx && vm.textCtx.measureText(text).width,
    createTextMap: createPaintSourceText,
    reloadData: vm.loadLocalData,
    setCurrentDeptLevel: setDeptIndent,
  }
  return _useAutoWidgetPlugins(vm, params)
}



// WEBPACK FOOTER //
// ./src/public/components/kye-canvas-table/widget/text-flex/auto-widget.js